import { validateAddressIndex } from '../Validation';

import { InputField, InputFieldProps } from './InputField';

export const ZipCodeField: React.FC<Omit<InputFieldProps, 'withTextMask'>> = (props) => {
  return (
    <InputField
      label="Індекс"
      {...props}
      withMask
      inputMaskType="text"
      mask="99999"
      minLength={5}
      validator={validateAddressIndex}
      formatInputValue={(value) => value.replaceAll('_', '')}
      change={props.change}
    />
  );
};
